
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#FFF"}},[_c('path',{attrs:{"d":"M2.706 9.9v5.502c0 .832.669 1.498 1.5 1.498.833 0 1.5-.668 1.5-1.498V9.9h-3z"}}),_c('path',{attrs:{"d":"M4.53 16.887v.013h10.473a2.498 2.498 0 002.497-2.501V3.5H5.7v6.7l.001.762.002 1.72v.243l.003 2.67c0 .725-.582 1.208-1.176 1.292z"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M8 9h4.8M8 6.6h5.6M8 11.4h6.4M8 13.8h4"}})])])
      }
    
      }
    